module.exports = __webpack_public_path__ + "assets-cabinet/img/circle-plus-icon.353d4270.svg";